export enum ZendeskCategory {
  ProductDocumentation = 7887915269268,
  AgencyDocumentation = 23155395224852,
  ReleaseNotes = 11040248190996,
  APIDocs = 17711059927572,
  BestPractices = 21798401799444,
  Videos = 6861437340948,
}

export enum ZendeskCategoryName {
  ProductDocumentation = 'ProductDocumentation',
  AgencyDocumentation = 'AgencyDocumentation',
  ReleaseNotes = 'ReleaseNotes',
  APIDocs = 'PublicApiDoc',
  BestPractices = 'BestPractices',
  Videos = 'Videos',
}

export enum ZendeskArticleFeature {
  Video = 'video',
  Audio = 'audio',
  Link = 'link',
}

export enum ZendeskItemType {
  Folder = 'Section',
  Article = 'Article',
}

export enum ZendeskSection {
  ProductDocumentationDashboard = 7888345289492,
  ProductDocumentationNotifications = 7888372398612,
  ProductDocumentationCampaigns = 7888362126100,
  ProductDocumentationAnalytics = 7888358345492,
  ProductDocumentationLibraries = 7888376945684,
  ProductDocumentationAccount = 7888422148628,
  ProductDocumentationCreativeAuthoringAndManagement = 10205219021972,
  ProductDocumentationIntegrations = 12136115396756,
  ProductDocumentationCopilot = 40042238096788,
  ProductDocumentationGeneral = 12136120255636,
  AgencyDocumentationAdvertisers = 24490906377236,
  AgencyDocumentationAccount = 24490941604500,
  AgencyDocumentationDashboard = 25734745130900,
  AgencyDocumentationAnalytics = 25730122059156,
  APIDocsGettingStarted = 17711146466836,
  APIDocsAPIReference = 17711139284500,
  BestPracticesAnalytics = 37488116283156,
  StrategyDocumentation = 39405118090260,
  HowToVideosTemplatesAndCreatives = 42065115935252,
  HowToVideosCampaigns = 42065117725588,
  HowToVideosFeeds = 42065122953620,
  HowToVideosAccounts = 42065155642004,
}

export enum ZendeskSupportRequestType {
  SomethingIsntWorking = 'something_isn_t_working',
  GeneralQuestion = 'general_question',
  Request = 'request',
}

export enum AiZendeskSupportRequestType {
  SomethingIsntWorking = "Bug/Error (Something isn't working)",
  GeneralQuestion = 'General Question',
  Request = 'Request',
}

export enum ZendeskBusinessImpact {
  Normal = 'normal',
  HighImpactsLiveRevenue = 'high_-_impacts_live_revenue',
  BlockerImpactsFutureLaunch = 'blocker_-_impacts_future_launch',
}

export enum AiZendeskBusinessImpact {
  Normal = 'Normal',
  HighImpactsLiveRevenue = 'High - Impacts Live Revenue',
  BlockerImpactsFutureLaunch = 'Blocker - Impacts Future Launch',
}

